export const apiVersion = process.env.REACT_APP_API_VERSION
  ? `/${process.env.REACT_APP_API_VERSION}`
  : ''

export const useMockedApi = process.env.REACT_APP_USE_MOCKED_API === 'true'

export const apiBaseUrl = `${
  process.env.REACT_APP_API_BASE_URL || 'https://api.example.com'
}${apiVersion}`
